const styles = theme => ({
  dialog: {
    maxWidth: 900
  },
  closeButton: {
    position: 'absolute',
    right: 0
  },
  title: {
    '& h2': {
      fontFamily: 'Roboto-Bold',
      fontSize: 20,
      color: '#202A38',
      paddingTop: 50
    }
  },
  modalContent: {
    fontSize: 16,
    color: '#202A38',
    display: 'flex',
    flexDirection: 'row',
    padding: 40,
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  labelsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: 35,
    marginBottom: 10
  },
  buttonsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 60
  },
  button: {
    padding: '15px 55px',
    textTransform: 'none',
    fontSize: 16,
    fontFamily: 'Roboto-Bold'
  },
  buttonCancel: {
    color: theme.palette.primary.main,
    marginRight: 10
  },
  inputField: {
    '& input': {
      padding: 15,
    }
  },
  inputFieldSelect: {
    width: '100%',
    '& > div': {
      paddingTop: 15,
      paddingBottom: 15
    }
  },
  inputLabel: {
    fontFamily: 'Roboto-Bold'
  },
  helpText: {
    color: '#80858C',
    fontSize: 10,
    textTransform: 'uppercase'
  },
  loadWrapper: {
    backgroundColor: 'white',
    opacity: 0.9,
    display: 'flex',
    position: 'absolute',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconWrapper: {
    marginRight: 15,
    '& svg': {
      width: 36,
      height: 36
    }
  },
  messageWrapper: {}
})

export default styles;